module.exports = __webpack_public_path__ + "static/media/arrowDown.769f8d1b.svg";